import React from "react";
import { useFormContext } from "react-hook-form";
import MainButton from "../../../../../../../shared/components/MainButton";
import Text from "../../../../../../../shared/components/Text";
import { useNationalities } from "../../../../../../../../utils/hooks/useNationalities/useNationalities";

export const AddressFormSubmitter = ({ onSubmitForm, edit, setEdit }) => {
  const { handleSubmit, getValues, setValue, watch } = useFormContext();
  const { nationalities } = useNationalities();

  const disabled = !watch("address.address");

  const getCountryLongName = (values) =>
    nationalities.find(
      (nationality) => nationality.value === values.address.country
    )?.label;

  const formatAddressValues = (values) => ({
    address: {
      ...values.address,
      address: `${values.address.streetName}${
        values.address.streetNumber ? ` ${values.address.streetNumber}` : ""
      }, ${values.address.postalCode} ${values.address.city}, ${
        values.address.province ? ` ${values.address.province},` : ""
      } ${getCountryLongName(values) ?? values.address.country}`,
    },
  });

  const handleEditValues = (values) => {
    setValue("address.address", values.address.address);
    setValue(
      "address.countryLongName",
      nationalities.find(
        (nationality) => nationality.value === values.address.country
      )?.label ?? values.address.country
    );
    setValue("address.latitude", null);
    setValue("address.longitude", null);
    setEdit(false);
  };

  return (
    <MainButton
      color={edit ? "secondary" : "primary"}
      variant={"contained"}
      disabled={disabled}
      onClick={handleSubmit(() =>
        edit
          ? handleEditValues(formatAddressValues(getValues()))
          : onSubmitForm(formatAddressValues(getValues()))
      )}
    >
      <Text tId={edit ? "CONFIRM_DATA" : "CONTINUE"} />
    </MainButton>
  );
};
